// extracted by mini-css-extract-plugin
export var accordionHeading = "cookieBanner-module--accordion-heading--24rY8";
export var accordionItem = "cookieBanner-module--accordion-item--lHUHI";
export var consentButton = "cookieBanner-module--consent-button--02k9w";
export var container = "cookieBanner-module--container--rlNt5";
export var cookieList = "cookieBanner-module--cookie-list--ILGGT";
export var labelText = "cookieBanner-module--label-text--sy48i";
export var toggleButton = "cookieBanner-module--toggle-button--8ZzFn";
export var toggleButtonLabel = "cookieBanner-module--toggle-button-label--7cdm6";
export var translateCookieBanner = "cookieBanner-module--translateCookieBanner--sywFX";